<template>
   <div id="RightSide">
      <ul class="rightSide">
         <!-- 客服 -->
         <li class="kefu" title="客服">
            <div class="div">
               <div title="QQ在线交谈">
                  <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=502324825&site=qq&menu=yes">
                     <img src="@/assets/images/rightSide/service_QQ.png" class="qq_jiaotan" />
                     <p>QQ在线交谈</p>
                     <p>502324825</p>
                  </a>
               </div>
               <div title="电话">
                  <img src="@/assets/images/rightSide/service_call.png"/>
                  <p>客服: 13272494143</p>
                  <p>商务: 13272494143</p>
               </div>
            </div>
         </li>
         <!-- 微信公众号 
         <li class="gongzhonghao" title="微信公众号">
            <div class="div">
               <P>关注微信公众号</P>
               <img src="/assets/images/weixin/wx_gzh.jpg" />
            </div>
         </li>
         -->
         <!-- 意见反馈 
         <li class="feedback" title="意见反馈" @click.stop="showFeedBackModal">
            
         </li>
         -->
         <!-- 回到顶部 -->
         <BackTop></BackTop>
      </ul>
   </div>
</template>
<script>
export default {
  name: "RightSide",
  data() {
    return {
      
    };
  },
}
</script>
<style lang="less" scoped>
   .rightSide{
      width: 42px;
      height: 42px;
      background-color: #fff;
      border: 1px solid #E3E8EA;
      position: fixed;
      right: 10px;
      bottom: 317px;
      padding: 2px;
      color: #686E71;
      z-index:3;
      li{
         width: 36px;
         height: 36px;
         margin-bottom: 1px;
         cursor: pointer;
         position: relative;
      }
      .kefu{
         background: url('../../assets/images/rightSide/rightside_service_normal.png') no-repeat;
         background-size: 100% 100%;
         .div{
            position: absolute;
            width: 264px;
            height: 172px;
            background-color: #fff;
            border: 1px solid #E3E8EA;
            top: 0;
            left: -267px;
            display: none;
            padding: 15px;
            div{
               float: left;
               width: 116px;
               text-align: center;
               color:#686E71;
            }
            .qq_jiaotan{
               width: 80px;
               height: 80px;
               border-radius: 50%;
               margin: 12px 18px 10px;
            }
            p{
               font-size: 12px;
            }
         }
      }
      .kefu:hover{
         background: url('../../assets/images/rightSide/rightside_service_hover.png') no-repeat;
         background-size: 100% 100%;
         .div{
            display: block;
         }
      }
      /* 正常的未被访问过的链接*/
      .kefu a:link{
         text-decoration:none;
      }
      .gongzhonghao{
         background: url('../../assets/images/rightSide/rightside_QR_normal.png') no-repeat;
         background-size: 100% 100%;
         .div{
            position: absolute;				
            width: 140px;
            height: 156px;
            background-color: #fff;
            border: 1px solid #E3E8EA;
            top: 0;
            left: -143px;
            display: none;
            padding: 15px;
            p{
               text-align: center;
               line-height: 17px;
               margin-bottom: 9px;
               font-size: 12px;
            }
            img{
               width: 100px;
               height: 100px;
            }
         }
      }
      .gongzhonghao:hover{
         background: url('../../assets/images/rightSide/rightside_QR_hover.png') no-repeat;
         background-size: 100% 100%;
         .div{
            display: block;
         }
      }
      .feedback{
         background: url('../../assets/images/rightSide/rightside_notice_normal.png') no-repeat;
         background-size: 100% 100%;
         .div{
            position: absolute;		
            width: 240px;
            height: 496px;
            background-color: #fff;
            border: 1px solid #E3E8EA;
            top: -200px;
            left: -242px;
            // display: none;
            padding: 15px;
            p{
               line-height: 22px;
               margin-bottom: 10px;
               font-size: 12px;
            }
         }
      }
      .feedback:hover{
         background: url('../../assets/images/rightSide/rightside_notice_hover.png') no-repeat;
         background-size: 100% 100%;
      }
   }
</style>


// WEBPACK FOOTER //
// src/components/rightSide/RightSide.vue